import { defineComponent as _defineComponent } from 'vue'
import { computed, provide } from 'vue';
import { Platform } from '@/@types/graphql-types';
import { SingleStepContext } from '@/features/sports/helpers/config';
import {
	GetSportProvidersByShortNamesDocument,
	GetSportProvidersByShortNamesQuery,
	GetSportProvidersByShortNamesQueryVariables,
} from '@/features/sports/graphql/queries/GetSportProvidersByShortNames.query';
import SportsFooter from '@/features/sports/components/global/SportsFooter.vue';
import TimeZoneSwitcher from '@/features/sports/components/global/TimeZoneSwitcher.vue';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { useQuery } from '@/helpers/composables/useApollo';
import { useRoute } from 'vue-router/composables';
import { SPORT_PROVIDERS_BY_SHORT_NAME_KEY } from '@/features/sports/types/sports-types';


export default /*#__PURE__*/_defineComponent({
  __name: 'SportsLayout',
  props: {
    context: null
  },
  setup(__props: any) {



const route = useRoute();
const { country } = useLanguageStore();
const queryVariables = computed<GetSportProvidersByShortNamesQueryVariables>(() => {
	return {
		country: country.value,
		platform: Platform.Web,
	};
});
const enabled = computed(() => Boolean(route.name?.startsWith('app.sports')));

const { result } = useQuery<GetSportProvidersByShortNamesQuery, GetSportProvidersByShortNamesQueryVariables>(
	GetSportProvidersByShortNamesDocument,
	queryVariables,
	{
		enabled,
	}
);

const sportProvidersByShortName = computed(() => {
	return result.value?.packages ?? [];
});

provide(SPORT_PROVIDERS_BY_SHORT_NAME_KEY, sportProvidersByShortName);

return { __sfc: true,route, country, queryVariables, enabled, result, sportProvidersByShortName, SportsFooter, TimeZoneSwitcher }
}

})